/**
 * Appends UTM tracking parameters to a dealer website URL.
 * Used to track traffic from Dealer Pages (FLD, DDP) for attribution.
 *
 * @param {string} url - The dealer website URL to append UTM parameters to
 * @returns {string} - The URL with UTM tracking parameters appended, or empty string if no valid URL
 */
const appendUtmTracking = (url) => {
    if (!url || typeof url !== 'string' || url.trim() === '') {
        return '';
    }

    const utmParams = 'utm_source=autotrader&utm_medium=referral&utm_campaign=listing_referral&utm_content=view_website_cta';

    // Check if URL already has query parameters
    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}${utmParams}`;
};

export default appendUtmTracking;
